<template v-if="closingChecklistItems.length > 0">
  <div id="closing-checklist-list">
    <template v-for="(item, index) in closingChecklistItems" class="mt-3">
      <three-state-cb v-if="item.type === 'THREE-STATE' || item.type === 'TWO-STATE'"
                      :key="item.key"
                      :checkbox_id="item.key"
                      @3SCBChanged="threeStateBoxChanged"
                      :label="item.question"
                      :cb_type="(item.type === 'THREE-STATE')?'3SCB':'2SCB'"
                      :state="item.current_state"
                      :disabled="formDisabled"
                      :tabindex="(index + 1)"
      ></three-state-cb>

      <v-textarea v-if="item.type === 'OPEN-QUESTION'" :key="index"
                  v-model="item.answer"
                  counter
                  :maxlength="maxTextLength"
                  no-resize
                  rows="2"
                  ref="inputRef"
                  :label="item.question"
                  :disabled="formDisabled"
                  :rules="textRules"
                  :tabindex="(index + 1)"
      ></v-textarea>
    </template>
  </div>
</template>


<script>
import ThreeStateCheckboxComponent from "@/components/modules/global/three-state-checkbox/ThreeStateCheckboxComponent";

export default {
  name: "ClosingChecklistListComponent",
  data: () => ({
    maxTextLength : 500,
    minTextLength : 2
  }),
  props: {
    closingChecklistItems: {
      type: Array
    },
    formDisabled: {
      type: Boolean
    }
  },
  components: {
    threeStateCb: ThreeStateCheckboxComponent,
  },
  methods: {
    threeStateBoxChanged($event) {
      //console.log($event.id);
      //console.log('BEFORE');
      //console.log(this.customQuestions);
      this.closingChecklistItems.find(x => x.key === $event.id)['current_state'] = $event.state;
      //console.log('AFTER');
      //console.log(this.customQuestions);
    },
  },
  computed : {
    maxTextLengthRule(){
      return v => (v || '').length <= this.maxTextLength || `A maximum of ${this.maxTextLength} characters is allowed`;
    },
    requiredTextRule(){
      return v => (v || '').length >= this.minTextLength || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
    },
    textRules() {
      const rules = [];
      const min_length_rule = this.requiredTextRule;
      const max_length_rule = this.maxTextLengthRule;
      rules.push(min_length_rule);
      rules.push(max_length_rule);
      return rules;
    },
  }
}
</script>

<style scoped>

</style>